<template>
  <div class="container">
    <p class="page-description">
      Comece a usar o minhamola <strong>hoje</strong>.
    </p>
    <span v-if="isCORSError" class="error-cors-message"
      @click="reloadPage">
        Ocorreu um erro. Clique aqui para recarregar a página &#9932;</span>
    <span v-if="OTPnotSent"
        @click="OTPnotSent = !OTPnotSent" class="failure-message">
        Número de celular inválido. &#9932;</span>
    <form @submit.prevent="attemptSignUp">
      <label for="phoneNumber"
        >Código do país e Número de celular *
        <span class="phone-input-container">
          <input @change="focusOnNextInput(); checkCountryCodeValiidty()"
            type="tel" inputmode="tel" list="country-codes"
            class="country-code-input" v-model="countryCode"
            autocomplete="tel-country-code" minlength="2" maxlength="5" required>
          <input
            class="phone-number-input"
            @focus="clearErrors"
            type="tel"
            inputmode="tel"
            autocomplete="tel"
            v-model="phoneNumber"
            id="phoneNumber"
            minlength="5"
            required
          />
        </span>
        <span class="notice-message">
          Um SMS será enviado para este número com um código de confirmação.</span>
        <span v-if="phoneNumberInUse" class="error-message">
          Número de celular em uso.</span>
        <span v-if="isCountryCodeInvalid" class="error-message">
          Falta o '+' no código do país.</span>
      </label>
      <datalist id="country-codes">
        <option v-for="c in countryCodesList" :value="c.dialCode"
          :key="c.dialCode" :selected="c.selected">{{c.dialCode}}</option>
      </datalist>
      <label for="email"
        >Email (opcional)
        <input
          @focus="clearErrors"
          type="email"
          autocomplete="email"
          inputmode="email"
          v-model="email"
          name="new-email"
          id="email"
        />
        <span v-if="emailInUse" class="error-message">
          Email em uso.</span>
      </label>
      <label class="password-label" for="password"
        >Palavra-passe *
        <input
          :type="inputType"
          inputmode="text"
          autocomplete="new-password"
          v-model="password"
          name="new-password"
          id="password"
          required
        />
      </label>
      <label class="visibility-toggle" for="show-password-button">
        <input @click="isPassword = !isPassword" type="checkbox" id="show-password-button" />
        <span role="button">Mostrar palavra-passe</span>
      </label>
      <span id="recaptcha-container"></span>
      <AppButton :text="textForButton" :disabled="isSigningUp" />
      <p @click="goToRoute" id="/entrar" class="link-button" role="button">Entrar</p>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import AppButton from "@/components/AppButton.vue";
import countryCodes from "@/misc/countryCodes";
import { mountRecaptchaVerifier, sendOTP } from "@/firebase/index";
import { parseUserId, requestBuilder } from "../misc/util";

export default {
  name: "TheSignUp",
  components: {
    AppButton
  },
  created() {
    this.countryCodesList = countryCodes;
  },
  mounted() {
    this.focusOnNextInput();
    mountRecaptchaVerifier("recaptcha-container");
  },
  data() {
    return {
      email: "",
      phoneNumber: "",
      countryCode: "+258",
      password: "",
      phoneNumberInUse: false,
      emailInUse: false,
      isPassword: true,
      isSigningUp: false,
      isCountryCodeInvalid: false,
      OTPnotSent: false,
      isCORSError: false,
      countryCodesList: []
    };
  },
  computed: {
    inputType() {
      if (this.isPassword === true) return "password";
      return "text";
    },
    textForButton() {
      if (this.isSigningUp) return "Registando-me...";
      return "Registar-me";
    },
    completePhoneNumber() {
      const { length: countryCodeLength } = this.countryCode;
      const { length: phoneNumberLenght } = this.phoneNumber;
      if (countryCodeLength > 0 && phoneNumberLenght > 0) return `${this.countryCode}${this.phoneNumber}`;
      return "";
    },
  },
  methods: {
    ...mapActions(["changeUserId", "changeLoginState"]),
    reloadPage() {
      this.$router.go(0);
    },
    goToRoute(e) {
      const nextRoute = e.srcElement.id;
      const currentRoute = this.$route.path;

      if (currentRoute !== nextRoute) this.$router.push(nextRoute);
    },
    focusOnFirstInput() {
      const countryCodeInput = document.querySelector(".country-code-input");
      if (countryCodeInput) countryCodeInput.focus();
    },
    focusOnNextInput() {
      const phoneNumberInput = document.querySelector(".phone-number-input");
      if (phoneNumberInput) phoneNumberInput.focus();
    },
    checkCountryCodeValiidty() {
      if (this.countryCode.length > 0) {
        const hasPlusSign = this.countryCode.includes("+");
        if (hasPlusSign) this.isCountryCodeInvalid = false;
        else this.isCountryCodeInvalid = true;
      } else this.isCountryCodeInvalid = false;
    },
    requestData() {
      const data = {
        email: (this.email.length === 0 ? null : this.email),
        phoneNumber: this.completePhoneNumber,
        username: null,
        password: this.password,
        userType: "client",
        status: "active"
      };

      return data;
    },
    clearErrors() {
      this.phoneNumberInUse = false;
      this.emailInUse = false;
      this.OTPnotSent = false;
    },
    setErrorMessages(constraint) {
      if (constraint === "users_email_key") this.emailInUse = true;
      else this.phoneNumberInUse = true;
    },
    async logOut() {
      this.changeUserId(null);
      this.changeLoginState(false);

      const url = "/users/logout";
      const method = "GET";
      const requestOptions = requestBuilder(url, method);

      try {
        await axios.request(requestOptions);
      } catch (error) {
        console.log(error);
      }
    },
    async deleteCreatedUser() {
      const formattedPhoneNumber = `%2B${this.completePhoneNumber.slice(1)}`;
      const url = `/users/${parseUserId()}/?phonenumber=${formattedPhoneNumber}`;
      const method = "DELETE";
      const requestOptions = requestBuilder(url, method);

      try {
        await axios.request(requestOptions);
        await this.logOut();
      } catch (error) {
        console.log({ error });
      }
    },
    async attemptSignUp() {
      if (!this.isCountryCodeInvalid) {
        this.isSigningUp = true;
        this.OTPnotSent = false;

        const url = "/users";
        const method = "POST";
        const data = this.requestData();
        const requestOptions = requestBuilder(url, method, data);

        try {
          const { response } = await axios.request(requestOptions);
          sendOTP(this.completePhoneNumber)
            .then(async (res) => {
              if (res.code === "auth/invalid-phone-number") {
                await window.grecaptcha.reset(window.recaptchaVerifier.widgetId);
                this.deleteCreatedUser();
                this.OTPnotSent = true;
                this.isSigningUp = false;
              } else {
                document.querySelector("#recaptcha-container").remove();
                this.$router.push({ name: "OTPConfirmation", params: { phoneNumber: this.completePhoneNumber } });
                this.isSigningUp = false;
              }
            });
        } catch (error) {
          if (error.response.status === 422) {
            this.setErrorMessages(error.response.data.constraint);
            this.isSigningUp = false;
          } else {
            console.log({ error });
            this.isSigningUp = false;
          }
        }
      }
    }
  }
};
</script>

<style scoped>
label {
  color: var(--color-tertiary);
  margin: 0 0 1.6rem 0;
}

button {
  margin: 2px auto 0 auto;
  background-color: var(--color-primary);
  color: var(--color-quaternary);
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.page-description {
  margin-bottom: 1.6rem;
}

.failure-message {
  font-size: 0.833rem;
  color: var(--color-white);
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  background-color: var(--color-senary);
  width: fit-content;
  text-align: center;
  margin: 0 auto 1.6rem auto;
}

.container form {
  width: 100%;
  margin-bottom: 1.6rem;
}

.phone-input-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
}

.country-code-input,
.phone-number-input {
  width: 100%;
}

.country-code-input {
  grid-column: 1/3;
  border-radius: 10px 0 0 10px;
  border-right: 0;
  background-color: #FFCD56;
  color: var(--color-primary);
}

.phone-number-input {
  grid-column: 3/6;
  border-radius: 0 10px 10px 0;
  border-left: 0;
}

.password-label {
  margin-bottom: 0.8rem;
}

.visibility-toggle {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.6rem;
}

.visibility-toggle span {
  margin-top: 0.6px;
}

.visibility-toggle:focus-within {
  color: var(--color-secondary) !important;
}

.error-message {
  font-size: 0.833rem;
  color: var(--color-senary);
}

.notice-message {
  font-size: 0.694rem;
  color: var(--color-secondary);
}

.error-cors-message {
  font-size: 0.833rem;
  color: var(--color-white);
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  background-color: var(--color-senary);
  width: fit-content;
  text-align: center;
  margin: 0 auto 1.8rem auto!important;
  cursor: pointer;
}

.link-button {
  color: var(--color-secondary);
  text-align: center;
  margin: 1.6rem 0 0 0;
  cursor: pointer;
}
</style>
